import React, { Component } from 'react';
import { CheckIcon, GlobeIcon, LockIcon, ShieldIcon, ZapIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const included = ['120 Complete Ready-to-Teach Dance Fitness Classes', '120 Professional Choreography Systems', 'Complete Cueing & Coaching System', 'Class Planning Frameworks — organize a full year in minutes', 'Progressive Difficulty Systems for all levels', 'Music & Playlist Organization Guides', 'Warm-Up, Mobility & Cool-Down Libraries', 'Movement Combination Libraries', 'Class Structure Templates — 30, 45 & 60-minute sessions', 'Instructor Cue Sheets with coaching phrases', 'Participant Progress & Attendance Trackers', 'Class Preparation Checklists', 'Printable Instructor Resources', 'Bonus 1 — 100 Ready-to-Use Dance Fitness Class Ideas', 'Bonus 2 — 50 Complete Dance Fitness Class Plans', 'Bonus 3 — 365 Warm-Ups, Cool-Downs & Movement Combinations', 'Bonus 4 — Dance Fitness Monthly Challenges', 'Bonus 5 — Instructor Planner & Business Toolkit', '7-Day Money-Back Guarantee', 'Immediate Access · PDF Format · Local Currency'];
export function PricingSection() {
  return <section id="pricing" className="bg-charcoal px-4 py-20 text-white" data-id="element-178">
      <div className="mx-auto max-w-3xl" data-id="element-179">
        <header className="mb-9 text-center" data-id="element-180">
          <p className="text-xs font-bold uppercase tracking-[.18em] text-gold-light" data-id="element-181">
            Your complete offer today
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold sm:text-5xl" data-id="element-182">
            The complete teaching system + 5 strategic bonuses
          </h2>
          <p className="mt-3 text-sm text-zinc-400" data-id="element-183">
            Ready for your very next class.
          </p>
        </header>

        <article className="relative rounded-3xl border border-gold/50 bg-charcoal-card p-1 shadow-[0_0_45px_rgba(212,175,55,.12)]" data-id="element-184">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gold px-4 py-1 text-xs font-bold tracking-wide text-black" data-id="element-185">
            COMPLETE TEACHING PACKAGE
          </span>
          <div className="rounded-[1.3rem] bg-charcoal p-6 text-center sm:p-10" data-id="element-186">
            <h3 className="font-display text-3xl font-bold text-gold-light" data-id="element-187">
              Dance Fitness Instructor Pro™
            </h3>
            <p className="mt-2 text-sm text-zinc-400" data-id="element-188">
              Everything you need to teach dance fitness with confidence,
              consistency, and energy — every week of the year.
            </p>
            <ul className="mx-auto my-6 max-w-md space-y-2 rounded-xl border border-gold/20 bg-gold/5 p-4 text-left" data-id="element-189">
              {included.map(item => <li key={item} className="flex gap-2 text-sm text-zinc-200" data-id="element-190">
                  <CheckIcon className="mt-0.5 shrink-0 text-gold-light" size={16} data-id="element-191" />
                  {item}
                </li>)}
            </ul>
            <p className="text-lg text-zinc-600 line-through" data-id="element-192">USD 105.00</p>
            <p className="mt-1 text-xl text-white" data-id="element-193">
              TODAY:{' '}
              <strong className="ml-1 text-4xl text-gold-light sm:text-5xl" data-id="element-194">
                USD 27.00
              </strong>
            </p>
            <CheckoutButton className="mt-7 w-full sm:w-auto" data-id="element-195">
              GET THE COMPLETE TEACHING SYSTEM NOW
            </CheckoutButton>
            <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-zinc-400" data-id="element-196">
              {[[LockIcon, 'Secure Payment'], [ZapIcon, 'Immediate Access'], [ShieldIcon, '7-Day Guarantee']].map(([Icon, label]) => {
              const IconComponent = Icon as typeof LockIcon;
              return <span key={String(label)} className="flex items-center gap-1" data-id="element-197">
                    <IconComponent size={13} className="text-gold-light" data-id="element-198" />
                    {String(label)}
                  </span>;
            })}
            </div>
            <p className="mx-auto mt-5 flex max-w-md items-start gap-2 rounded-xl border border-white/10 bg-white/5 p-3 text-left text-[11px] leading-relaxed text-zinc-400" data-id="element-199">
              <GlobeIcon size={14} className="mt-0.5 shrink-0 text-gold-light" data-id="element-200" />
              Pay in your local currency. The amount adjusts automatically based
              on the country you are purchasing from.
            </p>
          </div>
        </article>
      </div>
    </section>;
}